export default function getShiftTags(shift, orgTags) {
  const tags = [];
  if (shift.tags && shift.tags.length) {
    shift.tags.forEach((tag) => {
      const extendedTag = orgTags && orgTags.find((t) => t.id === tag.id);
      if (extendedTag) {
        tags.push(extendedTag);
      } else {
        tags.push(tag);
      }
    });
  }

  return tags;
}
